import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const EventCtaSection = () => {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <section className="bg-white py-20 px-6 text-center">
      <div
        ref={ref}
        className={`max-w-2xl mx-auto transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        <div className="inline-flex items-center gap-2 mb-4">
          <span className="h-px w-6 bg-brand-coral" />
          <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">Passez à l'action</span>
          <span className="h-px w-6 bg-brand-coral" />
        </div>
        <h2 className="font-serif text-4xl text-brand-anthracite mb-4">
          Demandez votre devis <em className="text-brand-fuchsia">personnalisé</em>
        </h2>
        <p className="text-brand-gray mb-8 leading-relaxed">
          Partagez votre vision avec nous et recevez un devis sur mesure adapté à vos besoins et à votre budget.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact#contact-form"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-medium text-sm whitespace-nowrap transition-all duration-300 hover:scale-105"
            style={{ background: 'linear-gradient(135deg, #e63e8b, #f78b49)' }}
          >
            <i className="ri-mail-send-line" />
            Demander un devis
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-brand-anthracite/20 text-brand-anthracite font-medium text-sm whitespace-nowrap transition-all duration-300 hover:border-brand-fuchsia hover:text-brand-fuchsia"
          >
            <i className="ri-arrow-left-line" />
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </section>
  );
};

export default EventCtaSection;
